import Swiper from 'swiper'
import { EffectFade, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'

export default class Slider {
  constructor() {
    this.init()
  }

  init() {
    this.homeSlider()
  }

  homeSlider() {
    const btnPrev = document.querySelector('.js-home__slider__button__prev')
    const btnNext = document.querySelector('.js-home__slider__button__next')

    this.slider = new Swiper('.c-home__slider', {
      modules: [Navigation, EffectFade],
      loop: true,
      effect: 'fade',
      speed: 700,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        prevEl: btnPrev,
        nextEl: btnNext,
      },
    })
  }
}
